import type { SVGProps } from 'react';

const Dollar = (props?: SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.00001 12.8333C10.6694 12.8333 12.8333 10.6694 12.8333 7.99999C12.8333 5.33061 10.6694 3.16666 8.00001 3.16666C5.33063 3.16666 3.16667 5.33061 3.16667 7.99999C3.16667 10.6694 5.33063 12.8333 8.00001 12.8333Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.5 5.83334H7.58333C6.985 5.83334 6.5 6.31837 6.5 6.91668C6.5 7.51501 6.985 8.00001 7.58333 8.00001H8.41667C9.015 8.00001 9.5 8.48501 9.5 9.08334C9.5 9.68168 9.015 10.1667 8.41667 10.1667H6.5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 5.16666V5.49999"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M8 10.5V10.8333" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default Dollar;
